import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function EmpiezaSection() {
  return <section className="w-full bg-navy-darkest py-10 md:py-14" data-id="element-21">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6" data-id="element-23">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-cream" data-id="element-24">
            Hoy puedes empezar con el Método de 21 Noches
          </h2>

          <p className="text-lg text-cream-muted leading-relaxed" data-id="element-25">
            y comenzar a cambiar lo que tu cuerpo hace cada noche.
          </p>

          <p className="text-xl text-cream font-medium" data-id="element-26">
            No necesitas esperar más noches sintiéndote así.
          </p>

          <p className="font-playfair text-xl italic text-amber" data-id="element-27">
            Mientras más lo entiendas… más rápido cambia.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-10" data-id="element-28">
          <CTAButton className="w-full sm:w-auto" data-id="element-29">
            QUIERO DORMIR SIN DESPERTARME
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}